/*
 * Public API Surface of guru-admin-shell-angular
 */

export * from './lib/index';
